/* eslint-disable react-hooks/exhaustive-deps */
import Avatar from 'funifier-nice-avatar';

import { PointReviewItem } from 'components/point-review-item';
import { RewardReviewItem } from 'components/reward-review-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Box from 'components/ui/box';
import { useEffect, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { getMissaoGestorPublic, getMissaoEquipePublic } from 'services/achievement.service';
import { getKPIPublicHistoryByTime, getPlayerInfo } from 'services/dashboard.service';
import { getPublicProfile } from 'services/profile.service';
import { RedePoint } from 'pages/Rede/components/point';
import Humanograma from 'components/Humanograma';
import { useAuth } from 'context/AuthContext';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { useModal } from 'context/ModalContext';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import { getLevelTitle } from 'services/utils';
import { isGrupoValido } from 'utils/helpers';
import { SeloGaleria } from 'components/icons';

interface GaleriaConhecimentoDetailProps {
  id?: string;
  tab: any;
  onClose: () => void;
}
export function GaleriaConhecimentoDetail({ id, tab, onClose }: GaleriaConhecimentoDetailProps) {
  const { user } = useAuth();
  const [selectedUser, setSelectedUser] = useState<any>();
  const [userInfo, setUserInfo] = useState<any>();

  const [list, setList] = useState<unknown[]>();
  const [missionList, setMissionList] = useState<unknown[]>();

  const [loadingList, setLoadingList] = useState(true);
  const [loadingMissionList, setLoadingMissionList] = useState(true);

  const { showModal } = useModal();

  useEffect(() => {
    if (!id) {
      return;
    }

    async function loadPlayerInfo() {
      if (!id) return;
      // console.log(tab)

      const userProfile = await getPublicProfile(id, tab._id);
      const playerInfo = await getPlayerInfo(id);
      setUserInfo(playerInfo);
      setSelectedUser(userProfile);

      const isGestor =
        playerInfo.tipo_ro === 'GERENCIAL' ||
        playerInfo.funcao === 'DIRETOR' ||
        (Array.isArray(playerInfo.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => typeof md.tipo_ro === 'string' && md.tipo_ro === 'GERENCIAL'));

      if (isGestor) {
        const dataGestor = await getMissaoGestorPublic(id, tab.date_start, tab.date_end, tab._id);
        const dataEquipe = await getMissaoEquipePublic(id, tab.date_start, tab.date_end, tab._id);
        setMissionList([...dataGestor, ...dataEquipe]);
      } else {
        const data = await getMissaoEquipePublic(id, tab.date_start, tab.date_end, tab._id);
        setMissionList(data);
      }

      setLoadingMissionList(false);

      loadReconhecimentos();
    }

    async function loadReconhecimentos() {
      const result = await getKPIPublicHistoryByTime(id, tab.date_start, tab.date_end, tab._id);
      setList(result.filter((x: any) => !x.cancelled));
      setLoadingList(false);
    }

    loadPlayerInfo();
    // loadReconhecimentos();
  }, [id]);

  return (
    <div className="mx-auto container p-3 lg:p-10">
      <div className="flex flex-row items-center space-x-3 lg:space-x-2 mb-3 lg:mb-10">
        <button
          onClick={() => onClose()}
          className="rounded-full bg-purple flex justify-center items-center p-1"
          aria-label="Voltar para galeria de reconhecimento"
        >
          <RiArrowLeftSLine size={28} className="text-white" aria-hidden="true" />
        </button>
        <h1 className="text-lg lg:text-3xl py-1 px-6" tabIndex={0}>
          Reconhecimentos de {selectedUser?.name}
        </h1>
      </div>

      {userInfo && (
        <div className="bg-oxford-blue rounded-3xl p-10 mb-10 flex flex-col lg:flex-row space-y-3 justify-between">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-3 text-center lg:text-left">
            <div className="w-28 h-28 md:w-44 md:h-44 bg-purple flex items-center justify-center rounded-full overflow-hidden text-3xl md:text-6xl">
              {!!selectedUser.extra.avatar_type &&
                (selectedUser.image ? (
                  <img src={selectedUser.image.medium.url} alt={selectedUser.name} className="w-full h-full" />
                ) : (
                  selectedUser.name[0]
                ))}
              {!selectedUser.extra.avatar_type &&
                (!!selectedUser.extra.avatar ? (
                  <Avatar className="w-full h-full" {...selectedUser.extra.avatar} />
                ) : (
                  selectedUser.name[0]
                ))}
            </div>

            

            <div className="space-y-3">
              <Humanograma data={{ ...userInfo, _id: userInfo?.chave }}>
                <div className="text-lg md:text-2xl text-white font-bold">
                  {userInfo?.nome_guerra} <span className="font-thin">({selectedUser?._id})</span>
                </div>
              </Humanograma>
              {userInfo && (
                <div className="md:text-xl font-thin">
                  {selectedUser?.level && !!isGrupoValido(selectedUser?.grupo) && (
                    <div className="mb-4 flex items-center">
                      <span tabIndex={0}>
                        Nível: <b className="text-electric-blue">{getLevelTitle(selectedUser?.level)}</b>{' '}
                      </span>
                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={<>Nível definido.</>}
                      >
                        <span className="ml-2" aria-label="Nível definido">
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </span>
                      </Tippy>
                    </div>
                  )}

                  {selectedUser?.grupo ? (
                    <button
                      className="flex items-center space-x-2 text-left"
                      onClick={() => showModal('group-detail-extrato')}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          showModal('group-detail-extrato');
                        }
                      }}
                      aria-label={`Ver detalhes do grupo ${selectedUser?.grupo}, ${selectedUser?.grupo_total || userInfo?.grupo?.total} funcionários`}
                    >
                      <span>{selectedUser?.grupo ? selectedUser.grupo : userInfo?.grupo?.nome}</span>{' '}
                      <span>({selectedUser?.grupo_total ? selectedUser?.grupo_total : userInfo?.grupo?.total} funci) </span>{' '}
                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={<>O seu grupo de classificação está definido.</>}
                      >
                        <span className="ml-2" aria-label="O seu grupo de classificação está definido">
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </span>
                      </Tippy>
                      <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                        {userInfo?.ro}
                      </span>
                    </button>
                  ) : (
                    <div className="md:text-xl font-thin" tabIndex={0}>
                      <span>{userInfo?.grupo?.nome}</span> <span>({userInfo?.grupo?.total} funci)</span>{' '}
                      <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                        {userInfo?.ro}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {!!tab?.label && (
            <div
              className="flex flex-col justify-center items-center space-y-4"
              tabIndex={0}
              role="img"
              aria-label="Selo conquistado: Galeria do Reconhecimento"
            >
              <div aria-hidden="true">
                <SeloGaleria size={'114px'} cycle={tab.label} />
              </div>
              <b className="text-xl text-yellow" aria-hidden="true">Selo conquistado</b>
            </div>
          )}
        </div>
      )}

      <div className="w-full flex flex-col space-y-5">
        {!user?.extra.rede && (
          <Box>
            <section className="space-y-5 lg:p-3" aria-labelledby="realizacao-destaque-heading">
              <h2 id="realizacao-destaque-heading" className="text-2xl mb-3" tabIndex={0}>
                Realização Destaque
              </h2>

              {loadingMissionList ? (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              ) : null}

              {!loadingMissionList && (
                <div className="space-y-2">
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                    {missionList?.map((item: any) => <RedePoint key={item._id} data={item} />)}
                  </div>
                </div>
              )}
            </section>
          </Box>
        )}

        <Box>
          <section className="space-y-5 lg:p-3" aria-labelledby="reconhecimentos-heading">
            <h2 id="reconhecimentos-heading" className="text-2xl mb-3" tabIndex={0}>
              Reconhecimentos recebidos <b className="text-yellow">{list ? `(${list?.length})` : null}</b>
            </h2>

            {loadingList ? (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            ) : null}

            {!loadingList ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {list?.map((item: any) => <RewardReviewItem data={item} key={item._id} />)}
              </div>
            ) : null}
          </section>
        </Box>
      </div>

      {selectedUser?._id && selectedUser?.grupo && <GroupDetailModalExtrato player={selectedUser?._id} cycleLabel={tab?.label} />}
    </div>
  );
}
